export function getSubdomain(domain: string): string {
  // domain might contain a port, e.g., "example.com:3000", let's remove it
  const [host] = domain.split(":");

  // during development, we can hardcode the domain via an environment variable
  return import.meta.env.VITE_SUBDOMAIN &&
    window.location.hostname.indexOf(host) === -1
    ? import.meta.env.VITE_SUBDOMAIN
    : window.location.hostname.replace(`.${host}`, "");
}
